const trim = (n) => n.toFixed(2).replace(/\.?0+$/, '');

/**
 * Amount read out the Indian way, for hover hints on big figures:
 * 7898699 → "₹78.99 lakh", 54065000 → "₹5.41 crore", 45200 → "₹45.2 thousand".
 */
export function inrLakhCrore(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  const sign = n < 0 ? '−' : '';
  const abs = Math.abs(n);
  const units = [
    [1e7, 'crore'],
    [1e5, 'lakh'],
    [1e3, 'thousand']
  ];
  for (let i = 0; i < units.length; i += 1) {
    const [size, name] = units[i];
    if (abs >= size) {
      const scaled = Math.round((abs / size) * 100) / 100;
      // 99,99,999 rounds to "100 lakh" — say "1 crore" instead.
      if (i > 0 && scaled * size >= units[i - 1][0]) {
        return `${sign}₹${trim(scaled * size / units[i - 1][0])} ${units[i - 1][1]}`;
      }
      return `${sign}₹${trim(scaled)} ${name}`;
    }
  }
  return `${sign}₹${Math.round(abs)}`;
}
